var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-pin",
    d: "M6.74993 0C4.95393 0.00853486 3.23463 0.729114 1.96923 2.00366C0.703819 3.27821 -0.00436941 5.00264 2.0286e-05 6.79866C2.0286e-05 12.1236 6.11544 17.6263 6.37494 17.8573C6.47822 17.9492 6.61167 18 6.74993 18C6.8882 18 7.02165 17.9492 7.12493 17.8573C7.38443 17.6248 13.4998 12.1258 13.4998 6.79866C13.5042 5.00264 12.7961 3.27821 11.5306 2.00366C10.2652 0.729114 8.54594 0.00853486 6.74993 0ZM6.74993 10.4999C6.00826 10.4999 5.28325 10.2799 4.66657 9.86789C4.0499 9.45584 3.56926 8.87017 3.28543 8.18496C3.00161 7.49974 2.92734 6.74575 3.07204 6.01834C3.21673 5.29092 3.57388 4.62274 4.09832 4.0983C4.62276 3.57386 5.29094 3.21671 6.01836 3.07202C6.74577 2.92732 7.49976 3.00159 8.18498 3.28541C8.87019 3.56924 9.45586 4.04988 9.86791 4.66655C10.28 5.28323 10.4999 6.00824 10.4999 6.74991C10.4987 7.7441 10.1032 8.69722 9.40024 9.40022C8.69724 10.1032 7.74412 10.4987 6.74993 10.4999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinBlack);
export default __webpack_public_path__ + "static/media/location-pin-black.ee10ec1181baa519f397a2836bad9339.svg";
export { ForwardRef as ReactComponent };